/**
 * Single API client for all Worker endpoints.
 *
 * Uses cookie-based authentication (HttpOnly `token` cookie set by Worker).
 * Browser automatically sends cookies with `credentials: 'include'`.
 *
 * Base URL is read from `process.env.REACT_APP_API_URL`.
 */

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8787';

const apiClient = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true, // Send HttpOnly cookies with every request
});

// Attach Bearer token from localStorage as fallback for cross-origin requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 → redirect to login
apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { apiClient, API_BASE };
